// Store/BoostTaskStore.ts
import { create } from 'zustand';
import { BoostTask } from '../Pages/Mining/types/boost';

interface BoostTaskState {
  currentTask: BoostTask | null;
  setCurrentTask: (task: BoostTask | null) => void;
}

export const useBoostTaskStore = create<BoostTaskState>((set) => ({
  currentTask: null,
  setCurrentTask: (task) => set({ currentTask: task }),
}));
